import Api from "./baseApi";

export default {
  searchMpProduct: mpProduct => {
    let url = "/api/mpproducts?v=1";
    if (mpProduct.search) url += `&q=${mpProduct.search}`;
    if (mpProduct.onSale !== null && mpProduct.onSale !== undefined) url += `&onSale=${mpProduct.onSale}`;
    return Api.get(url);
  },
  getMpProducts: () => Api.get("/api/mpproducts"),
  getMpProduct: id => Api.get(`/api/mpproducts/${id}`),
  putMpProduct: mpProduct => Api.put(`/api/mpproducts/${mpProduct.id}`, mpProduct),
  deleteMpProduct: mpProduct => Api.delete(`/api/mpproducts/${mpProduct.id}`, mpProduct),
  postMpProduct: mpProduct => Api.post(`/api/mpproducts`, mpProduct),
  checkSku: (mpSku, excludeId) => Api.get(`/api/mpproducts/check-sku`, { params: { mpSku, excludeId } }),

  getMissingProducts: () => Api.get("/api/mpproducts/missing-products"),
  getMpProductByProduct: productId => Api.get(`/api/mpproducts/by-product/${productId}`),
  syncFromMainProducts: productIds => Api.post("/api/mpproducts/sync-from-main", productIds),
  getMpProductsByMarketplace: () => Api.get("/api/mpproducts/by-marketplace"),
  n11Excel: (ids, aciklama) => Api.post(`/api/mpproducts/n11-excel?aciklama=${aciklama}`, ids, { responseType: "blob" }),
  getMpProductsForCarousel: (q = null) => {
    let url = "/api/mpproducts/for-carousel";
    if (q) url += `?q=${q}`;
    return Api.get(url);
  }
};

